import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllVendaAnimal } from '../service';
import {
  LIST_VENDA_ANIMAL,
  LIST_VENDA_ANIMAL_PENDING,
  LIST_VENDA_ANIMAL_SUCCESS,
  LIST_VENDA_ANIMAL_FAILURE
} from '../actionTypes';

function* sagaListAllVendaAnimal(action) {
  yield put({ type: LIST_VENDA_ANIMAL_PENDING })

  try {
    const list = yield call(findAllVendaAnimal)
    
    yield put({ type: LIST_VENDA_ANIMAL_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_VENDA_ANIMAL_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllVendaAnimal() {
  yield takeLatest(LIST_VENDA_ANIMAL, sagaListAllVendaAnimal)
}